import { Resolution } from '../utilities/types';

export const KEY = 'FRAMING_AND_WORKING_RESOLUTION_CALCULATORS';
export const LABEL = 'Framing and Working Resolution Calculators';

/**
 * Netflix logo dimensions from the actual asset file
 * These are used for aspect ratio calculations without needing to load the image
 */
export const NETFLIX_LOGO_DIMENSIONS: Resolution = {
  width: 1800,
  height: 756,
};

/**
 * Netflix logo asset path
 */
export const NETFLIX_LOGO_PATH = '/Netflix_Logo_RGB.png';
